import { defineStore } from "pinia";
import { i18n } from "@/common/i18n";
import { storage } from "@/common/services/storage";

export const LOCALE_STORAGE_KEY = "app_locale";
export type AppLocale = "es" | "en";

export const useLocaleStore = defineStore("locale", {
  actions: {
    async setLocale(lang: AppLocale): Promise<void> {
      (i18n.global.locale as any).value = lang;
      await storage.set(LOCALE_STORAGE_KEY, lang);
    },
  },
});
